"use strict";

var _defineProperty = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scene = void 0;

var validation_1 = require("../../validation");

var displayable_1 = require("../shared/displayable");

var feature_toggles_1 = require("./feature-toggles");

var scene_parcels_1 = require("./scene-parcels");

var source_1 = require("./source");

var spawn_point_1 = require("./spawn-point");
/** @alpha */


var Scene;

(function (Scene) {
  Scene.schema = {
    type: 'object',
    properties: _objectSpread(_objectSpread({
      main: {
        description: "File that contains the entry point of the scene's code",
        type: 'string',
        minLength: 1
      },
      scene: scene_parcels_1.SceneParcels.schema
    }, displayable_1.displayableProperties), {}, {
      display: {
        description: 'Information related to how should this land be displayed apart from the normal rendering of the scene',
        type: 'object',
        properties: {
          title: {
            description: 'A name so other users can identify what the contents of this land should be',
            type: 'string',
            nullable: true
          },
          favicon: {
            description: 'DEPRECATED. Allow the land owner to set up a favicon to this land',
            type: 'string',
            nullable: true
          },
          description: {
            description: "A description that will be shown on client's nav map when the scene is selected",
            type: 'string',
            nullable: true
          },
          navmapThumbnail: {
            type: 'string',
            nullable: true
          }
        },
        nullable: true,
        additionalProperties: false,
        required: []
      },
      owner: {
        type: 'string',
        nullable: true
      },
      contact: {
        description: 'Describe different ways of contacting the land owner',
        type: 'object',
        properties: {
          name: {
            type: 'string',
            nullable: true
          },
          email: {
            type: 'string',
            nullable: true
          },
          im: {
            type: 'string',
            nullable: true
          },
          url: {
            type: 'string',
            nullable: true
          }
        },
        nullable: true,
        additionalProperties: false,
        required: []
      },
      tags: {
        type: 'array',
        items: {
          type: 'string',
          minLength: 1
        },
        nullable: true
      },
      source: _objectSpread(_objectSpread({}, source_1.Source.schema), {}, {
        nullable: true
      }),
      spawnPoints: {
        type: 'array',
        items: spawn_point_1.SpawnPoint.schema,
        nullable: true
      },
      requiredPermissions: {
        type: 'array',
        items: {
          type: 'string'
        },
        nullable: true
      },
      featureToggles: _objectSpread(_objectSpread({}, feature_toggles_1.FeatureToggles.schema), {}, {
        nullable: true
      })
    }),
    additionalProperties: false,
    required: ['main', 'scene']
  };
  Scene.validate = (0, validation_1.generateValidator)(Scene.schema);
})(Scene = exports.Scene || (exports.Scene = {}));